import type { Price } from "./currency";

export const coinSymbols: { [key: string]: string } = {
  mSOL: "mSOL",
  MNDE: "MNDE",
  SOL: "SOL",
  USDC: "USDC",
  laineSOL: "laineSOL",
  cgntSOL: "cgntSOL",
  bSOL: "bSOL",
  daoSOL: "daoSOL",
  jitoSOL: "jitoSOL",
  stSOL: "stSOL",
  jSOL: "jSOL",
  lpSOL: "lpSOL",
} as const;

export type CoinSymbols = (typeof coinSymbols)[keyof typeof coinSymbols];
export type Prices = {
  [key in CoinSymbols]?: Price;
};
